export default __webpack_public_path__ + "static/media/thriving-pop-label.a3611357.svg";